var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cell-compensation",
      class: {
        "cell-compensation-hover":
          _vm.record.compensation.is_need && _vm.canEdit,
        "cell-compensation_disabled": !_vm.canEdit,
      },
      on: { click: _vm.showCompensationModal },
    },
    [
      _c("m-compensation", {
        attrs: {
          active: _vm.isShowCompensationModal,
          record: _vm.record,
          "calc-data": _vm.calculationData,
        },
        on: {
          close: function ($event) {
            _vm.isShowCompensationModal = false
          },
          sendCompensationValue: _vm.setCompensation,
        },
      }),
      _c(
        "div",
        {
          staticClass: "cell-compensation-value",
          class: {
            "cell-compensation-value-grey": _vm.record.compensation.value === 0,
          },
        },
        [_vm._v(" " + _vm._s(_vm.record.compensation.value) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }